// services/api.js
import axios from 'axios';
import { useAuthStore } from '../stores/auth';
import config from '../config';



// API pública (sin autenticación)
export const publicApi = axios.create({
  baseURL: `${config.apiUrl}/api/public`,
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// API para autenticación, balance y configuración de usuario
export const api = axios.create({
  baseURL: config.endpoints.api, // URL dinámica para autenticación
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// API para juegos, categorías y proveedores
export const gamesApi = axios.create({
  baseURL: config.endpoints.games, // URL dinámica para juegos
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});
gamesApi.getFavorites = function() {
  return this.get('/groups/games/favorites'); // ✅ Corregido: Se agregó `groups`
};

gamesApi.toggleFavorite = function(gameId) {
  return this.post(`/groups/games/favorites/${gameId}`); // ✅ Corregido
};

// Interceptores de autorización
// REEMPLAZA tu función setupAuthInterceptor actual con esta:
const setupAuthInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Manejar error 401 (no autenticado)
      if (error.response?.status === 401) {
        const authStore = useAuthStore();
        authStore.clearAuthenticatedUser();
      }
      
      // NUEVO: Manejar error 403 con panic mode
      if (error.response?.status === 403 && error.response?.data?.code === 'panic_mode') {
        console.log('🚨 Panic mode detected! Redirecting to YouTube...');
        
        // Limpiar autenticación
        const authStore = useAuthStore();
        authStore.clearAuthenticatedUser();
        
        // Limpiar tokens del localStorage
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        
        // Redirigir a YouTube
        if (error.response.data.redirect_url) {
          window.location.href = error.response.data.redirect_url;
        } else {
          window.location.href = 'https://www.youtube.com';
        }
        
        // Prevenir que el error se propague
        return new Promise(() => {});
      }
      
      return Promise.reject(error);
    }
  );
};

// Añadir después de la creación de las instancias axios
[api, gamesApi].forEach(instance => {
  instance.interceptors.request.use(config => {
      const token = localStorage.getItem('token');
      if (token) {
          config.headers.Authorization = `Bearer ${token}`;
      }
      config.withCredentials = true;
      return config;
  });
});

// Configurar interceptores en las APIs privadas
setupAuthInterceptor(api);
setupAuthInterceptor(gamesApi);
